import { Section } from "@/components/ds/Section/Section";
import { Container } from "@/components/ds/Container/Container";
import { Stack } from "@/components/ds/Stack/Stack";

import { Card } from "@/components/ds/Card/Card";
import { Heading } from "@/components/ds/Heading/Heading";
import { Text } from "@/components/ds/Text/Text";
import { Button } from "@/components/ds/Button/Button";
import { Reveal } from "@/components/ds/Reveal/Reveal";
import { UsersIcon } from "@/icons/UsersIcon";
import { SmartphoneIcon } from "@/icons/SmartphoneIcon";
import { ShieldIcon } from "@/icons/ShieldIcon";
import styles from "./ForEveryone.module.css";

const PERSONAS = [
  {
    icon: UsersIcon,
    title: "For owners & managers",
    items: [
      "Live dashboard, every site and every shift in one view",
      "Drag-and-drop weekly rota with clash warnings",
      "Missed check-ins surface at the top automatically",
      "Filter the attendance log to answer any client question in seconds",
    ],
  },
  {
    icon: SmartphoneIcon,
    title: "For your team",
    subtitle: "Built for your team, not just about them.",
    items: [
      "Open TidyRota in any phone browser, no app to install",
      "See this week's shifts the moment you open the app",
      "Site address and postcode for every shift, no more chasing the owner",
      "Tap to check in at the site, GPS confirms you're there",
    ],
  },
  {
    icon: ShieldIcon,
    title: "When a client asks “were they there?”",
    items: [
      "GPS-verified attendance on record for every visit",
      "Check-in and check-out times to the minute",
      "Filter by date, site, or cleaner to answer on the spot",
      "Evidence sits in your dashboard, ready when you need it",
    ],
  },
] as const;

export function ForEveryone() {
  return (
    <Section background="cream">
      <Container>
        <Reveal>
          <Stack gap={10} align="center">
            <Heading level={2} size="h2">
              Built for everyone in your operation
            </Heading>

            <div className={styles.personaGrid}>
              {PERSONAS.map((persona) => (
                <Card key={persona.title} padding="lg" shadow>
                  <Stack gap={5}>
                    <persona.icon
                      width={28}
                      height={28}
                      className={styles.icon}
                    />
                    <Heading level={3} size="h3">
                      {persona.title}
                    </Heading>
                    {"subtitle" in persona && persona.subtitle && (
                      <Text size="sm" color="emerald" weight="medium">
                        {persona.subtitle}
                      </Text>
                    )}
                    <ul className={styles.list}>
                      {persona.items.map((item) => (
                        <li key={item} className={styles.listItem}>
                          <Text size="sm" color="primary">
                            {item}
                          </Text>
                        </li>
                      ))}
                    </ul>
                  </Stack>
                </Card>
              ))}
            </div>

            <Button href="#get-started" variant="accent" size="lg">
              Start with your team
            </Button>
          </Stack>
        </Reveal>
      </Container>
    </Section>
  );
}
